<template>
  <div class="dice-storm">
    <div class="main-title">使用帮助/互动游戏/点数风暴</div>
    <h1 class="page-title">点数风暴</h1>
    <h4 class="content-text">
      （1）首先在后台设置时间、奖项和价格。
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-diceStorm1_17682895518155b3115.webp"
      alt="酒吧大屏互动摇骰子游戏"
      class="example-image"
    />
    <h4 class="content-text">
      （2）进入大屏后，选择“点数风暴”进入。
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-diceStorm2_17682895518156de058.webp"
      alt="酒吧大屏互动游戏摇骰子奖品设置"
      class="example-image"
    />
    <h4 class="content-text">
      （3）用户扫描二维码在手机端点击开始游戏，等待大屏开始。
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-diceStorm3_1768289551816af2387.webp"
      alt="微信扫码参与酒吧大屏互动点数风暴游戏"
      class="mobile-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-diceStorm4_176828955181608b083.webp"
      alt="等待酒吧大屏互动点数风暴摇骰子游戏开始"
      class="mobile-image"
    />
    <h4 class="content-text">
      （4）用户可以选择摇一次，连摇五次或十次，点数最大即为挑战成功，可以上榜，领取奖励。
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-diceStorm5_17682895518163be72c.webp"
      alt="连续摇多次骰子进行点数风暴游戏"
      class="mobile-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-diceStorm6_17682895518163b7fd7.webp"
      alt="酒吧点数风暴摇骰子游戏结果展示"
      class="mobile-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-diceStorm7_1768289551816d0cdbf.webp"
      alt="挑战成功获得酒吧摇骰子游戏第一名"
      class="example-image"
    />
  </div>
</template>

<script>
export default {
  name: 'DiceStorm',
};
</script>

<style lang="less" scoped>
.dice-storm {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.main-title {
  width: 100%;
  font-weight: 500;
  font-size: 20px;
  color: #E19BFF;
  text-align: left;
  margin-top: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E19BFF;
}

.page-title {
  width: 100%;
  font-weight: 700;
  font-size: 32px;
  color: #FFFFFF;
  text-align: left;
  margin-top: 10px;
}

.content-text {
  width: 100%;
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
  text-align: left;
  word-wrap: break-word;
  word-break: break-all;
  margin-top: 10px;
}

.example-image {
  width: 100%;
  height: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}

.mobile-image {
  width: 241px;
  height: auto;
  margin: 10px auto;
  display: block;
}
</style>
